import fb from '@/firebaseConfig';
import { sortByTitle } from '@/helpers/helpers';
/*

  STATE

 */

const state = {
  favoriteIds: [],
};


/*

  GETTERS

 */

const getters = {
  sortedFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    const unsortedIds = state.favoriteIds;
    return sortByTitle(allCards, unsortedIds);
  },

  journeyFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    return getters.sortedFavIds.filter(id => (
      allCards[id] ? allCards[id].category === 'journey' : false
    ));
  },

  deepeningFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    return getters.sortedFavIds.filter(id => (
      allCards[id] ? allCards[id].category === 'deepening' : false
    ));
  },

  lighteningFavIds: (state, getters, rootState) => {
    const { allCards } = rootState.cards;
    return getters.sortedFavIds.filter(id => (
      allCards[id] ? allCards[id].category === 'lightening' : false
    ));
  },

  indexInFavorites: (state, getters, rootState) => {
    const { currentId } = rootState.ui;
    const { sortedFavIds } = getters;
    return sortedFavIds.indexOf(currentId);
  },
};


/*

  ACTIONS

 */

const actions = {

  toggleFavorite({ commit, dispatch, getters, rootState }) {
    const cardId = rootState.ui.currentId;
    const { uid } = rootState.user;
    const { sortedFavIds, indexInFavorites } = getters;
    const favoriteIds = [...sortedFavIds];

    if (indexInFavorites === -1) {
      favoriteIds.push(cardId);
      dispatch('analytics/saveFavorite', cardId, { root: true });
    } else {
      favoriteIds.splice(indexInFavorites, 1);
      dispatch('analytics/removeFavorite', cardId, { root: true });
    }
    commit('setFavorites', favoriteIds);

    fb.usersCollection.doc(uid).set({
      favoriteIds,
    }, { merge: true })
      .catch((error) => {
        console.error('Error writing document: ', error);
      });
  },
};


/*

  MUTATIONS

 */

const mutations = {
  setFavorites(state, favoriteIds) {
    if (favoriteIds) {
      state.favoriteIds = favoriteIds;
    }
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
